import { ApiRoutesInterface } from '@/interfaces/api-routes.interface'

const apiRoutes: ApiRoutesInterface = {
  arriveAdmin: {
    getSettings: () => 'arrive-parking',
    put: 'arrive-parking',
  },
  arriveParking: {
    getAvailability: (date: string) => `parking/availability?date=${date}`,
    getLocation: (locationId: number) => `parking/locations/${locationId}`,
  },
}

export { apiRoutes }
